import React, { useContext, useEffect, useState } from "react";
import {
  DropDown,
  Input,
  SignUpWithGoogle,
  ToastError,
  ToastSuccess,
} from "../global/component";
import { Link, useNavigate } from "react-router";
import AuthContext from "../global/auth-context";
import {
  RequestOtpService,
  RequestSignUpOtpService,
  SignupService,
} from "../models/ApiService";
import { Analytics } from "@vercel/analytics/react";
import HeaderNav from "../components/HeaderNav";

const SignUp = () => {
  const [username, setUsername] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [country, setCountry] = useState(null);
  const [countryFlag, setCountryFlag] = useState(null);
  const [password1, setPassword1] = useState(null);
  const [password2, setPassword2] = useState(null);
  const [selectCountry, setSelectCountry] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const [errors, setErrors] = useState({});
  const [isError, setIsError] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [hide, setHide] = useState(true);
  const [select, setSelect] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [requesOtp, setRequestOtp] = useState(false);
  const [otp1, setOtp1] = useState(null);
  const [otp2, setOtp2] = useState(null);
  const [otpExpiry, setOtpExpiry] = useState(null);

  let { countries, setCountries, countriesData, login, users, fetchUsers } =
    useContext(AuthContext);

  let navigate = useNavigate();

  const validateForm = () => {
    let errors = {};

    // Validate name field
    if (!username) {
      errors.username = "username  is required.";
    } else if (username.length < 5) {
      errors.username = "username must be at least 5 characters.";
    } else if (filteredUserName.length > 0) {
      errors.username = "username already exists";
    }

    // Validate email field
    if (!email) {
      errors.email = "Email is required.";
    } else if (!/@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid.";
    } else if (filteredEmail.length > 0) {
      errors.email = `email already exists, Login instead`;
    }

    // Validate phone field
    if (!phone) {
      errors.phone = "Phone Number is required.";
    } else if (phone.length < 6) {
      errors.phone = "phone Number must be at least 6 digits.";
    } else if (phone.includes("+") == false) {
      errors.phone = "phone Number must include country code.";
    }

    // Validate password field
    if (!password1) {
      errors.password1 = "password is required.";
    } else if (password1.length < 6) {
      errors.password1 = "Password must be at least 6 characters.";
    }

    // Validate password field
    if (!password2) {
      errors.password2 = "confirm password is required.";
    } else if (password2.length < 6) {
      errors.password2 = "Password must be at least 6 characters.";
    } else if (password1 != password2) {
      errors.password2 = "passwords do not match.";
    }

    if (!country) {
      errors.country = "country is required";
    }

    // Set the errors and update form validity
    setErrors(errors);
    setIsFormValid(Object.keys(errors).length === 0);
  };

  useEffect(() => {
    validateForm();
  }, [username, email, password1, password2, phone, country]);

  function loginButtom(params) {
    return <a>Login</a>;
  }

  useEffect(() => {
    fetchUsers();
  }, [username, email]);

  const [filteredCountries, setFilteredCountries] = useState([]);
  const [filteredUserName, setFilteredUserName] = useState([]);
  const [filteredEmail, setFilteredEmail] = useState([]);

  const HandleSearchCountries = (e) => {
    const SearchQuery = e.target.value;

    setSearchCountry(SearchQuery);

    const filteredItems = countries.filter((country) =>
      country.name.toLowerCase().includes(SearchQuery.toLowerCase())
    );

    setFilteredCountries(filteredItems);
  };

  const HandleSearchUsername = (e) => {
    const SearchQuery = e.target.value;

    setUsername(SearchQuery);

    const filteredItems = users.filter(
      (user) => user.userName.toLowerCase() === SearchQuery.toLowerCase()
    );

    setFilteredUserName(filteredItems);
  };

  const HandleSearchEmail = (e) => {
    const SearchQuery = e.target.value;

    setEmail(SearchQuery);

    const filteredItems = users.filter(
      (user) => user.email.toLowerCase() === SearchQuery.toLowerCase()
    );

    setFilteredEmail(filteredItems);
  };

  async function RequestSignUpOtpFunction(params) {
    let payload = { email, username };
    let response = await RequestSignUpOtpService(payload);
    if (response.success == true) {
      ToastSuccess(response.message);
      setSubmit(true);
      setRequestOtp(true);
      setOtp1(response.data.otpNumber);
      setOtpExpiry(response.data.otpExpiry);
      window.scrollTo(0, 0);
    } else {
      ToastError(response.message);
    }
  }

  async function ResendOtpFunction(params) {
    let payload = { email, username };
    let response = await RequestSignUpOtpService(payload);
    if (response.success == true) {
      ToastSuccess(response.message);
      setOtp1(response.data.otpNumber);
      setOtpExpiry(response.data.otpExpiry);
      console.log(response);
    } else {
      ToastError(response.message);
    }
  }

  async function VerifyEmailFunction(params) {
    let CurrentTime = new Date(Date.now());
    let ExpiryTime = new Date(otpExpiry);

    if (!otp2) {
      ToastError("Enter Otp.");
    } else if (otp2 != otp1) {
      ToastError("Otp is incorrect.");
    } else if (CurrentTime > ExpiryTime && otp2 == otp1) {
      ToastError("Otp expired.");
    } else if (CurrentTime <= ExpiryTime && otp2 == otp1) {
      let payload = {
        email,
        username,
        phone,
        country,
        password: password1,
        countryFlag,
      };
      let response = await SignupService(payload);
      if (response.success == true) {
        ToastSuccess(response.message);
        login(email.toLowerCase());
        navigate("/");
        window.scrollTo(0, 0);
        console.log(response);
      } else {
        ToastError(response.message);
      }
    }
  }

  return (
    <>
      <Analytics />
      <HeaderNav />
      <div className="bg-myLightGreen px-5 py-10 lg:py-10 flex justify-center flex-col md:flex-row gap-10 lg:gap-20">
        {!requesOtp && (
          <>
            <div className="flex items-center md:items-center md:justify-start md:pt-20 flex-col gap-5 md:w-1/3">
              <text>Sign Up with</text>
              <SignUpWithGoogle navigate={navigate} />
            </div>
            <div className="w-full flex flex-col md:w-1/2 gap-10 ">
              <text className="font-bold text-xl md:text-2xl text-myNormalGreen">
                Or Get Started!
              </text>

              <form className="flex gap-3 flex-col relative">
                <div className="flex gap-3 flex-col lg:flex-row w-full">
                  <div className="flex w-full lg:flex-1 flex-col h-fit">
                    <input
                      autocomplete="on"
                      className="px-5 w-full h-12 rounded-full border-2 border-myNormalGreen outline-none"
                      placeholder={"Username"}
                      borderColor={"#016401"}
                      type="text"
                      value={username}
                      onChange={HandleSearchUsername}
                    />
                    <text className="text-red-500 px-5">{errors.username}</text>
                  </div>
                  <div className="flex w-full lg:flex-1 flex-col h-fit">
                    <input
                      autocomplete="on"
                      className="px-5 w-full h-12 rounded-full border-2 border-myNormalGreen outline-none"
                      placeholder={"Email"}
                      borderColor={"#016401"}
                      type="email"
                      value={email}
                      onChange={HandleSearchEmail}
                    />
                    <text className="text-red-500 px-5">{errors.email}</text>
                  </div>
                </div>
                <div className="flex gap-3 flex-col lg:flex-row items-start">
                  <div className="flex w-full lg:flex-1 flex-col h-fit">
                    <input
                      className="px-5 w-full h-12 rounded-full border-2 border-myNormalGreen outline-none"
                      placeholder={"Phone"}
                      borderColor={"#016401"}
                      type="string"
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                    />
                    <text className="text-red-500 px-5">{errors.phone}</text>
                  </div>
                  <div
                    className={` flex w-full lg:flex-1 relative  flex-col justify-center`}
                  >
                    <Link
                      onClick={() => {
                        setSelectCountry(true);
                      }}
                      className={`${
                        selectCountry ? "" : "rounded-full"
                      } flex flex-1 relative justify-between border-myNormalGreen border-2 bg-white  items-center`}
                    >
                      {!country && !selectCountry && (
                        <DropDown Text={"Select Country"} />
                      )}
                      {country && !selectCountry && (
                        <Link
                          onClick={() => {
                            setSelectCountry(true);
                          }}
                          className="flex gap-2 p-3 cursor-pointer items-center justify-center w-full"
                        >
                          <img
                            src={countryFlag}
                            style={{ height: 15, width: 15 }}
                          />
                          <text
                            style={{
                              fontWeight: 500,
                              fontSize: 15,
                              color: "black",
                            }}
                          >
                            {country}
                          </text>
                        </Link>
                      )}
                      {selectCountry && (
                        <input
                          className="h-10 w-full outline-0 px-5 "
                          placeholder="Search Country"
                          value={searchCountry}
                          onChange={HandleSearchCountries}
                        />
                      )}
                    </Link>

                    <text className="text-red-500 px-5">{errors.country}</text>
                    {selectCountry && (
                      <>
                        <div className="overflow-y-scroll  flex absolute w-full h-60 top-12 flex-col bg-white border-2 border-myNormalGreen">
                          {searchCountry && filteredCountries.length < 1 && (
                            <text className="text-center text-myNormalGreen font-bold py-2">
                              No Country Found
                            </text>
                          )}
                          {searchCountry
                            ? filteredCountries.map((item, index) => {
                                return (
                                  <>
                                    <Link
                                      onClick={() => {
                                        setCountry(item.name.toLowerCase());
                                        setCountryFlag(
                                          `https://flagcdn.com/48x36/${item.iso2.toLowerCase()}.png`
                                        );
                                        setSelectCountry(false);
                                      }}
                                      className="flex gap-2 p-3 hover:bg-myLightGreen cursor-pointer items-center"
                                    >
                                      <img
                                        src={`https://flagcdn.com/48x36/${item.iso2.toLowerCase()}.png`}
                                        style={{ height: 15, width: 15 }}
                                      />
                                      <text
                                        style={{
                                          fontWeight: 500,
                                          fontSize: 15,
                                          color: "black",
                                        }}
                                      >
                                        {item.name}
                                      </text>
                                    </Link>
                                  </>
                                );
                              })
                            : countries.map((item, index) => {
                                return (
                                  <Link
                                    onClick={() => {
                                      setCountry(item.name.toLowerCase());
                                      setCountryFlag(
                                        `https://flagcdn.com/48x36/${item.iso2.toLowerCase()}.png`
                                      );
                                      setSelectCountry(false);
                                    }}
                                    className="flex gap-2 p-3 hover:bg-myLightGreen cursor-pointer items-center"
                                  >
                                    <img
                                      src={`https://flagcdn.com/48x36/${item.iso2.toLowerCase()}.png`}
                                      style={{ height: 15, width: 15 }}
                                    />
                                    <text
                                      style={{
                                        fontWeight: 500,
                                        fontSize: 15,
                                        color: "black",
                                      }}
                                    >
                                      {item.name}
                                    </text>
                                  </Link>
                                );
                              })}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="flex gap-3 flex-col lg:flex-row">
                  <div className="flex w-full lg:flex-1 flex-col h-fit">
                    <input
                      id=""
                      className="px-5 w-full h-12 rounded-full border-2 border-myNormalGreen outline-none"
                      placeholder={"Password"}
                      borderColor={"#016401"}
                      type="password"
                      value={password1}
                      onChange={(e) => {
                        setPassword1(e.target.value);
                      }}
                    />
                    <text className="text-red-500 px-5">
                      {errors.password1}
                    </text>
                  </div>
                  <div className="flex w-full lg:flex-1 flex-col h-fit">
                    <input
                      className="px-5 w-full h-12 rounded-full border-2 border-myNormalGreen outline-none"
                      placeholder={"Confirm Password"}
                      borderColor={"#016401"}
                      type="password"
                      value={password2}
                      onChange={(e) => {
                        setPassword2(e.target.value);
                      }}
                    />
                    <text className="text-red-500 px-5">
                      {errors.password2}
                    </text>
                  </div>
                </div>
                <Link
                  onClick={RequestSignUpOtpFunction}
                  type="submit"
                  className="md:py-2 self-center bg-myNormalGreen py-1 text-white font-bold text-lg w-full text-center rounded-xl"
                >
                  Register
                </Link>
              </form>

              <text className="-mt-3 px-3 font-medium text-center md:text-2xl pb-20">
                Already have an account?{" "}
                <a href="/login" className="text-myNormalGreen">
                  Login
                </a>
              </text>
            </div>
          </>
        )}
        {requesOtp && (
          <div className="w-full flex flex-col md:w-1/2 gap-10 ">
            <text className="font-bold text-xl md:text-2xl text-myNormalGreen">
              Verify Email
            </text>
            <div className="flex gap-5 flex-col ">
              <div className="flex w-full  flex-col h-fit">
                <input
                  className="px-5 h-12 rounded-full border-2 border-myNormalGreen outline-none"
                  placeholder={"Enter Otp"}
                  type={"string"}
                  value={otp2}
                  onChange={(e) => {
                    setOtp2(e.target.value);
                  }}
                />
              </div>
              <div>
                <a
                  onClick={ResendOtpFunction}
                  className="text-myNormalGreen float-end text-end -mt-3 px-3 font-medium w-fit"
                >
                  Resend Otp
                </a>
              </div>
            </div>
            <Link
              onClick={VerifyEmailFunction}
              className="md:py-2 self-center bg-myNormalGreen py-1 text-white font-bold text-lg w-full text-center rounded-xl"
            >
              Verify Email
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default SignUp;
